<!--  -->
<template>
  <div class="container">
    <!-- 公共头部 -->
    <Header></Header>
    <!-- 公共头部 -->
    <!-- 轮播图 -->
    <div class="carousel">
      <el-carousel :interval="4000" height="500px">
        <!-- <el-carousel-item v-for="item in image" :key="item.url">
          <img :src="item.url" class="bannerimg" />
        </el-carousel-item> -->
         <el-carousel-item>
          <img src="@/assets/9530.jpg" class="bannerimg" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/assets/9531.jpg" class="bannerimg" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图 -->
    <Introduction></Introduction>
    <MyFriend></MyFriend>
    <!-- 公共底部 -->
    <Footer></Footer>
    <!-- 公共底部 -->
    <!-- 侧边栏加回到顶部 -->
    <scollTop></scollTop>
    <!-- 侧边栏加回到顶部 -->
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import scollTop from "@/components/scollTop.vue";
import Introduction from "./modules/Introduction.vue";
import MyFriend from "./modules/MyFriend.vue";
export default {
  components: {
    Header,
    Footer,
    scollTop,
    Introduction,
    MyFriend
  },
  name: "ComponentName",
  data() {
    return {
      // image: [
      //   {
      //     url: "https://file.best-consulting.com/best-consulting/UploadFiles/20230920/170654503.jpg",
      //   },
      //   {
      //     url: "https://file.best-consulting.com/best-consulting/UploadFiles/20220207/152448338.jpg",
      //   },
      //   {
      //     url: "https://file.best-consulting.com/best-consulting/UploadFiles/20220207/152631088.jpg",
      //   },
      //   {
      //     url: "https://file.best-consulting.com/best-consulting/UploadFiles/20220207/152655416.jpg",
      //   },
      // ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 20px;
}
.bannerimg {
  height: 100%;
  width: 100%;
  margin-top: 4px;
  object-fit: cover;
}
// 修改轮播图指示器效果
.carousel /deep/ .el-carousel__indicators--horizontal {
  position: absolute !important;
  bottom: 5px !important;
  text-align: right !important;
  .el-carousel__indicator--horizontal button {
    width: 6px !important;
    height: 6px !important;
    background: #ffffff !important;
    border-radius: 50% !important;
    opacity: 0.5 !important;
  }

  .el-carousel__indicator--horizontal.is-active button {
    width: 14px !important;
    height: 6px !important;
    background: #ffffff !important;
    opacity: 1 !important;
    border-radius: 10px !important;
  }
}
::v-deep .el-carousel__arrow--left {
  font-size: 30px;
}

//右箭头
::v-deep .el-carousel__arrow--right {
  font-size: 30px;
}
</style>
